// packages/api/src/axios-client.ts
import axios from 'axios';

const baseURL = process.env.SSO_PUBLIC_API_URL || 'https://atajoy.com/ssoapi';

export const ssoClientNOc = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  // ✅ بسیار مهم: فعال کردن ارسال/دریافت کوکی‌ها
//   withCredentials: true
});

// ✅ Request interceptor برای اضافه کردن token از cookie
ssoClientNOc.interceptors.request.use(
  (config) => {
    // در سمت server کوکی‌ها از request می‌آید
    if (typeof window === 'undefined') {
      // Server-side: نیاز به cookie header دارد
      console.log('🔧 [ssoClientNOc] Server-side request');
    } else {
      // Client-side: مرورگر خودش کوکی‌ها رو می‌فرسته (با withCredentials: true)
      console.log('🔧 [ssoClientNOc] Client-side request - cookies auto-sent');
    }
    return config;
  },
  (error) => {
    console.error('❌ [ssoClientNOc] Request error:', error);
    return Promise.reject(error);
  }
);

// ✅ Response interceptor برای هندل کردن خطاها
ssoClientNOc.interceptors.response.use(
  (response) => {
    console.log('✅ [ssoClientNOc] Response success:', response.config.url);
    return response;
  },
  (error) => {
    console.error('❌ [ssoClientNOc] Response error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message
    });
    
    // اگر 401 بود، یعنی unauthorized
    if (error.response?.status === 401) {
      console.error('🔒 [ssoClientNOc] Unauthorized - token invalid or expired');
      
      // می‌تونید اینجا رفتار مشخصی داشته باشید:
      // - پاک کردن کوکی‌ها
      // - ریدایرکت به صفحه لاگین
      // - تلاش برای refresh token
      
      // مثال: اگر در client-side بودیم
      if (typeof window !== 'undefined') {
        // window.location.href = '/auth/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default ssoClientNOc;